/**
 * Ensures hex colors from the map are useable in CSS
 * Converts them from `0x...` to `#...`
 */
export const convertMapColor = (inputColor: string) => inputColor.replace('0x', '#')
